import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { RoomsService } from '../../services/rooms.service';
import { availableRoomsActions } from '.';
import { ApiError } from '../../models/common/api-error';
import { of } from 'rxjs';
import { AvailableRoomsState } from './available-rooms.state';
import { storeAvailableRoomsKey } from '../reducers';

@Injectable({
  providedIn: 'root',
})
export class AvailableRoomsEffects {
  constructor(
    private store$: Store,
    private actions$: Actions,
    private roomsService: RoomsService,
  ) {}

  findall$ = createEffect(() =>
    this.actions$.pipe(
      ofType(availableRoomsActions.findAll, availableRoomsActions.setFilters),
      withLatestFrom(this.store$),
      mergeMap(([action, store]) => {
        const availableRoomsState: AvailableRoomsState =
          store[storeAvailableRoomsKey];
        return this.roomsService
          .findAvailable(availableRoomsState.filters)
          .pipe(
            map((response) =>
              availableRoomsActions.findAllSuccess({ rooms: response.data }),
            ),
            catchError((error: ApiError) =>
              of(availableRoomsActions.findAllError({ error: error.message })),
            ),
          );
      }),
    ),
  );
}
